import CONFIG from '../config/config';
import { instanceWithV2 as APIClient } from './SimpleAPIClient';

export type B2bStoreInviteEligibility = {
  eligible: boolean;
};

const PromosAPI = {
  getB2bStoreInviteEligibility: () =>
    APIClient(CONFIG.API_ENDPOINT).get<B2bStoreInviteEligibility>(
      '/v1/promos/b2b-store-invite/eligibility',
    ),
};

export default PromosAPI;
